import serviceTicketsComponent from './service_tickets.component';

let serviceTicketsModule = angular.module('serviceTickets', [])

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('/service-tickets');

        $stateProvider
            .state('serviceTickets', {
                url: '/service-tickets?encounterId',
                params: {
                    encounterId: {
                        dynamic: true
                    }
                },
                component: 'serviceTickets',
                data: {
                    requireLogin: true,
                    requireACL: 'service_tickets.all'
                },
                parent: 'app',
            })
    })

    .component('serviceTickets', serviceTicketsComponent)

    .name;

export default serviceTicketsModule;    


// WEBPACK FOOTER //
// ./client/app/components/service_tickets/index.js